export interface NavUser {
  displayName?: string | null;
  email?: string | null;
  photoURL?: string | null;
}

export function getDisplayName(user: NavUser): string {
  return user.displayName || user.email?.split("@")[0] || "Felhasználó";
}

export function getInitial(user: NavUser): string {
  return (user.displayName?.[0] || user.email?.[0] || "U").toUpperCase();
}
